import gql from 'graphql-tag';

const ModifierFragment = gql`
  fragment Modifier on Modifier {
    id
    name
    price
    quantity
    type
    unitPrice
    customInfo
  }
`;

export default ModifierFragment;


// WEBPACK FOOTER //
// ./src/graphql/fragments/item/ModifierFragment.js